module.exports = __webpack_public_path__ + "static/img/14000032.a1ac556c.png";